import React from 'react';
import './PacImportanceSection.css';

const PacImportanceSection = () => {
  return (
    <section className="df-importance-section">
      <div className="df-importance-container">
        {/* Lado Izquierdo: Título y Justificación */}
        <div className="df-importance-content">
          <span className="df-importance-badge">
            Proveedor Autorizado de Certificación
          </span>
          <h2 className="df-importance-title">
            ¿Por qué un PAC es importante para tu negocio?
          </h2>
          <p className="df-importance-desc">
            Porque al momento de integrar tus soluciones, contarás con el respaldo de un proveedor autorizado de certificación que validará y emitirá tus comprobantes fiscales con la seguridad de que en todo momento tendrán la validez técnica requerida por el SAT.
          </p>
        </div>

        {/* Lado Derecho: Grilla 2x2 de Iconos y Beneficios (Exacta a la muestra) */}
        <div className="df-importance-grid">
          {/* Item 1: Velocidad récord */}
          <div className="df-importance-feature">
            <svg className="df-importance-icon" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="13" cy="13" r="8"></circle>
              <path d="M13 9v4l2.5 2.5M11 2h4M2 10h4M3 14h3"></path>
            </svg>
            <p className="df-importance-feature-text">
              Realiza tu facturación electrónica <strong>por debajo de los 100 milisegundos</strong>.
            </p>
          </div>

          {/* Item 2: Automatización */}
          <div className="df-importance-feature">
            <svg className="df-importance-icon" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"></path>
            </svg>
            <p className="df-importance-feature-text">
              <strong>Automatiza tus procesos</strong> de timbrado y disminuye errores.
            </p>
          </div>

          {/* Item 3: Optimización de costos */}
          <div className="df-importance-feature">
            <svg className="df-importance-icon" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9"></circle>
              <path d="M15 9.5c-.5-1-1.6-1.5-3-1.5-1.7 0-3 .9-3 2s1.3 1.7 3 2 3 .9 3 2-1.3 2-3 2c-1.4 0-2.5-.5-3-1.5M12 6v2M12 16v2"></path>
            </svg>
            <p className="df-importance-feature-text">
              <strong>Optimiza los costos</strong> por certificación de CFDI.
            </p>
          </div>

          {/* Item 4: Control de obligaciones */}
          <div className="df-importance-feature">
            <svg className="df-importance-icon" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="4" width="18" height="12" rx="1.5"></rect>
              <path d="M2 20h20M9 10l2 2 4-4"></path>
            </svg>
            <p className="df-importance-feature-text">
              <strong>Lleva un buen control</strong> de tus obligaciones técnicas y fiscales.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PacImportanceSection;
